import { render, staticRenderFns } from "./ColorSelect.vue?vue&type=template&id=e3504a14&scoped=true"
import script from "./ColorSelect.vue?vue&type=script&lang=js"
export * from "./ColorSelect.vue?vue&type=script&lang=js"
import style0 from "./ColorSelect.vue?vue&type=style&index=0&id=e3504a14&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3504a14",
  null
  
)

export default component.exports